import React, { ReactElement } from "react";
import { MessageActions, MessageProps, MessageState } from "./MessageInterface";

interface Props {
    // eslint-disable-next-line no-undef
    children: JSX.Element | JSX.Element[];
}

export const MessageContext = React.createContext<MessageProps>({
    state: {
        isOpen: false,
        buttons: [],
    },
    actions: {} as MessageActions,
});
function MessageContexProvider({ children }: Props): ReactElement {
    const initialState: MessageState = {
        isOpen: false,
        buttons: [
            {
                buttonText: "OK",
                onClick: () => {}, // Will be updated after closeModal is defined
            },
        ],
    };
    const [messageState, setMessageState] =
        React.useState<MessageState>(initialState);
    
    const closeModal = () => {
        setMessageState(initialState);
    };
    
    // Update the initial state after closeModal is defined
    initialState.buttons[0].onClick = () => closeModal();
    const setMessage = (message: Partial<MessageState>) => {
        setMessageState({
            ...messageState,
            ...message,
        });
    };

    const showErrorMessage = (title: string) => {
        setMessageState({
            title,
            isOpen: true,
            titleApparencce: "danger",
            buttons: [
                {
                    buttonText: "OK",
                    onClick: () => closeModal(),
                },
            ],
        });
    };
    return (
        <MessageContext.Provider
            value={{
                state: messageState,
                actions: {
                    closeModal,
                    setMessage,
                    showErrorMessage,
                },
            }}
        >
            {children}
        </MessageContext.Provider>
    );
}
export { MessageContexProvider };
